import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { SanityProductBadge } from '@gelato-api-ui/core/sanity/sanity-product-badge';
import { ProductBadgeComponent } from '@product-catalogue/src/lib/category-shared/product-badge/product-badge.component';

@Component({
  standalone: true,
  selector: 'lib-product-feature-badge',
  templateUrl: './product-feature-badge.component.html',
  styleUrls: ['./product-feature-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProductBadgeComponent, AsyncPipe],
})
export class ProductFeatureBadgeComponent {
  @Input() set labelText(labelText: string) {
    this.labelText$.next(labelText);
  }
  @Input() set tooltipText(tooltipText: string) {
    this.tooltipText$.next(tooltipText);
  }

  labelText$ = new BehaviorSubject<string>(null);
  tooltipText$ = new BehaviorSubject<string>(null);

  productBadge$ = combineLatest([this.labelText$, this.tooltipText$]).pipe(
    map(
      ([labelText, tooltipText]): SanityProductBadge => ({
        name: labelText,
        background: '#5991ff',
        color: '#fff',
        tooltip: tooltipText,
      }),
    ),
  );
}
